module.exports = __webpack_public_path__ + "img/1557614101227708418.5ea66bdd.png";